/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { NoPreview } from "components/document/NoPreview";
import { downloadAssetFromDocApi } from "utils/DownloadUtility";
import {
  getNoPreviewErrorCode,
  shouldShowDownloadButton,
  shouldShowDownloadMessage
} from "selectors/documentViewSelectors";
import { getFileExtension } from "selectors/documentSelectors";
import { getShouldUseMobileModernViewer } from "selectors/appSelectors";
import { httpErrorCodes, noPreviewErrorCodes } from "constants/enums";
import { getStringIdForHttpErrorCode } from "utils/HttpErrorCodesUtils";

const mapStoreToProps = (stores, ownProps) => ({
  clickHandler: () => {
    downloadAssetFromDocApi(stores, {
      triggeredFrom: "noPreview"
    });
  },
  errorMessageId: (() => {
    const errCode = getNoPreviewErrorCode(stores);
    if (errCode >= httpErrorCodes.BAD_REQUEST) {
      return getStringIdForHttpErrorCode(errCode);
    }

    switch (errCode) {
      case noPreviewErrorCodes.PASSWORD_CANCELLED: {
        return "nopreview.error.passwordCancelled";
      }
      case noPreviewErrorCodes.CORRUPT_PDF: {
        return "default";
      }
      default: {
        return "nopreview.error.generic";
      }
    }
  })(),
  shouldShowDownloadButton: shouldShowDownloadButton(stores),
  shouldShowDownloadMessage: shouldShowDownloadMessage(stores),
  shouldUseMobileModernViewer: getShouldUseMobileModernViewer(stores),
  fileExtension: getFileExtension(stores).toLowerCase()
});

const NoPreviewContainer = inject(mapStoreToProps)(NoPreview);

export { NoPreviewContainer };
